import React from "react";
import { Link, useLocation } from "react-router-dom";

export const ServicesDetailsSidebar = ({
  hideContact = false,
  hideTitle = false,
}) => {
  const location = useLocation(); // Get the current route
  const services = [
    { label: "Management system consultancy", href: "/services-details" },
    { label: "Training & Development", href: "/services-details-2" },
    { label: "Documentation support", href: "/services-details-3" },
    { label: "Vendor Development Audits", href: "/services-details-4" },
    { label: "Product Certification", href: "/services-details-5" },
    { label: "Cost reduction program", href: "/services-details-6" },
  ];

  return (
    <aside className="services-sidebar">
      {hideTitle ? (
        <div className="services-cat-list mb-30">
          <ul className="list-wrap">
            {services.map((item) => (
              <li
                key={item.label}
                className={location.pathname === item.href ? "highlight" : ""}
              >
                <Link to={item.href}>
                  {item.label} <i className="flaticon-right-arrow"></i>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="services-widget">
          <h4 className="sw-title">Our Services</h4>
          <div className="services-cat-list">
            <ul className="list-wrap">
              {services.map((item) => (
                <li
                  key={item.label}
                  className={location.pathname === item.href ? "highlight" : ""}
                >
                  <Link to={item.href}>
                    {item.label} <i className="flaticon-right-arrow"></i>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </aside>
  );
};
